<template>
  <a class="blue-pill" :href="href"><slot /></a>
</template>

<script>
export default {
  props: ["href"],
};
</script>

<style lang="scss" scoped>
a.blue-pill {
  color: white;
  font-size: 14px;
  background: $dark-blue;
  font-family: Montserrat;
  font-weight: 800;
  padding: 1rem 2rem;
  border-radius: 100px;
  box-shadow: -13px 23px 46px 0px rgba(43, 136, 131, 0.41);
  transition: background-color 0.25s ease-out;
  display: block;
  letter-spacing: 3px;
  text-align: center;
  width: max-content;
  text-transform: uppercase;

  &:hover {
    background: $primary-blue;
  }

  .trial-button {
    display: none;
  }
}
</style>
